import { render, staticRenderFns } from "./Batch.vue?vue&type=template&id=01cfb14c&scoped=true&"
var script = {}
import style0 from "./Batch.vue?vue&type=style&index=0&id=01cfb14c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cfb14c",
  null
  
)

export default component.exports